import React from 'react';

import { RecaptchaModal as RawRecatpchaModal } from '../../components/RecaptchaModal';

let setModalVisible: (b: boolean) => void | undefined;

const RecaptchaModal = (): JSX.Element => {
    const [visible, setVisible] = React.useState(false);

    React.useEffect(() => {
        setModalVisible = setVisible;
    }, []);

    return <RawRecatpchaModal visible={visible} />;
};

export { RecaptchaModal, setModalVisible };
